import { render } from "./SubjectPage.vue?vue&type=template&id=c0d2b02e&scoped=true"
import script from "./SubjectPage.vue?vue&type=script&lang=js"
export * from "./SubjectPage.vue?vue&type=script&lang=js"

import "./SubjectPage.vue?vue&type=style&index=0&id=c0d2b02e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0d2b02e"]])

export default __exports__